// Access-token expiry check (KNOWN-BUGS #15). Kept free of Vue/store imports so it can be unit tested under any TZ.

// Refresh when the access token has less than this left. The API issues 5-minute tokens
// (JwtConfiguration:MinutesExpiration), so the buffer must stay well below that or every call refreshes.
export const REFRESH_BUFFER_MS = 60 * 1000;

/*
 * `expiration` is the instant the API returns ("2026-10-06T10:05:00Z", UTC). Compare instants (epoch ms) directly:
 * the old check rebuilt "now" from its UTC parts read back as local time, which shifted it by the browser's UTC offset.
 */
export function tokenNeedsRefresh(expiration, now = Date.now(), bufferMs = REFRESH_BUFFER_MS)
{
    var expiresAt = new Date(expiration).getTime();

    if(isNaN(expiresAt)) { return true; }

    return expiresAt - now < bufferMs;
}
